<template>
    <div class="mainbusinessModuleWarp">
        <div class="moduleTitle">人力资源网站服务</div>
        <div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position='top' :validate-on-rule-change="false">
                <div class="dialogformCenter">
                    <div class="bigTitle">一、从业人员</div>
                    <el-form-item label="1.网站性质：" prop="1">
                        <el-select v-model="ruleForm[1]" placeholder="请选择">
                            <!-- 以下后台数据 -->
                            <el-option label="A.经营性网站" value="A"></el-option>
                            <el-option label="B.非经营性网站" value="B"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="2.从业人员总数：" prop="2">
                        <el-input v-model="ruleForm[2]" placeholder="请输入"></el-input>
                    </el-form-item>

                    <el-form-item label=" 3.本科及以上学历人数：" prop="3">
                        <el-input v-model="ruleForm[3]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">二、服务内容</div>
                    <el-form-item label="4.是否提供单位招聘与用人推荐、个人求职与岗位推荐服务：" prop="4">
                        <el-radio-group v-model="ruleForm[4]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="5.是否能进行信息更新：" prop="5">
                        <el-radio-group v-model="ruleForm[5]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="6.增值服务数量：" prop="6">
                        <el-input v-model="ruleForm[6]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="7.信息更新频率：" prop="7">
                        <el-select v-model="ruleForm[7]" placeholder="请选择">
                            <!-- 以下后台数据 -->
                            <el-option label="A.实时" value="A"></el-option>
                            <el-option label="B.每日" value="B"></el-option>
                            <el-option label="C.每周" value="C"></el-option>
                            <el-option label="D.每月" value="D"></el-option>
                        </el-select>
                    </el-form-item>
                    <div class="bigTitle">三、业务体系</div>
                    <el-form-item label="8.是否具有技术支持、客户服务等岗位或部门：" prop="8">
                        <el-radio-group v-model="ruleForm[8]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="9.是否初步形成技术支持、客户服务的业务体系：" prop="9">
                        <el-radio-group v-model="ruleForm[9]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="10.是否具有健全的销售、技术支持、客户服务等业务体系：" prop="10">
                        <el-radio-group v-model="ruleForm[10]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="11.是否设有集团大客户管理岗位或部门：" prop="11">
                        <el-radio-group v-model="ruleForm[11]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="12.是否设立市场拓展、产品研发部门：" prop="12">
                        <el-radio-group v-model="ruleForm[12]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="13.是否具有集销售技术支持、客户服务、市场拓展、产品研发为一体化的服务体系：" prop="13">
                        <el-radio-group v-model="ruleForm[13]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">四、配套资源</div>
                    <el-form-item label="14.是否单位招聘、个人简历及相关信息库查询、统计等应规范：" prop="14">
                        <el-radio-group v-model="ruleForm[14]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label=" 15.是否具有正版杀毒软件：" prop="15">
                        <el-radio-group v-model="ruleForm[15]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="16.是否具有独立数据库：" prop="16">
                        <el-radio-group v-model="ruleForm[16]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="17.是否具有固定客服电话和邮箱：" prop="17">
                        <el-radio-group v-model="ruleForm[17]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="18.是否具有可自行管理设置域名的企业邮箱：" prop="18">
                        <el-radio-group v-model="ruleForm[18]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="19.是否具有简历模板、资料管理系统等：" prop="19">
                        <el-radio-group v-model="ruleForm[19]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="20.是否设有公共注册邮箱：" prop="20">
                        <el-radio-group v-model="ruleForm[20]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">五、运营数据</div>
                    <el-form-item label="21.有效单位注册数：" prop="21">
                        <el-input v-model="ruleForm[21]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 22.有效个人注册数：" prop="22">
                        <el-input v-model="ruleForm[22]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 23.数据库有效简历数：" prop="23">
                        <el-input v-model="ruleForm[23]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 24.日均浏览次数：" prop="24">
                        <el-input v-model="ruleForm[24]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">六、公益服务</div>
                    <el-form-item label=" 25.年举办公益性网络招聘活动次数：" prop="25">
                        <el-input v-model="ruleForm[25]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="26.自有或租有服务器数量：" prop="26">
                        <el-input v-model="ruleForm[26]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label=" 27.是否租用IDC机房的共享带宽100M以上：" prop="27">
                        <el-radio-group v-model="ruleForm[27]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="28.自建机房的宽带速度（M）：" prop="28">
                        <el-input v-model="ruleForm[28]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="29.自有或租用网络核心设备数量（台）：" prop="29">
                        <el-input v-model="ruleForm[29]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="30.自有或租用安全防护设备（台）：" prop="30">
                        <el-input v-model="ruleForm[30]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="31.自有或租用数据备份设备（台）：" prop="31">
                        <el-input v-model="ruleForm[31]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">七、材料归档</div>
                    <el-form-item label="32.材料归档率（%）：" prop="32">
                        <el-input v-model="ruleForm[32]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <div class="bigTitle">八、信息化管理程度</div>
                    <el-form-item label=" 33.是否具备招聘信息与求职信息网络发布管理工具：" prop="33">
                        <el-radio-group v-model="ruleForm[33]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label=" 34.是否具备招聘单位，求职个人网上自助服务的功能与管理工具：" prop="34">
                        <el-radio-group v-model="ruleForm[34]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label=" 35.是否具备用户业务经办流程的管理工具：" prop="35">
                        <el-radio-group v-model="ruleForm[35]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label=" 36.是否具备岗位供求信息的匹配与管理工具：" prop="36">
                        <el-radio-group v-model="ruleForm[36]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="  37.是否具备全业务全服务流程的信息化管理工具：" prop="37">
                        <el-radio-group v-model="ruleForm[37]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div class="bigTitle">九、客户投诉记录及处理</div>
                    <el-form-item label="38.是否设有投诉电话：" prop="38">
                        <el-radio-group v-model="ruleForm[38]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="39.接到投诉到介入处理再到反馈当事人处理结果所需时间（天）：" prop="39">
                        <el-input v-model="ruleForm[39]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="40.投诉及处理情况记录保存年限（年）：" prop="40">
                        <el-input v-model="ruleForm[40]" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="  41.是否有投诉及处理情况记录" prop="41">
                        <el-radio-group v-model="ruleForm[41]" placeholder="请选择">
                            <el-radio label="是"></el-radio>
                            <el-radio label="否"></el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <div class="dialogformBottomBtnBox" v-if="!result">
                    <el-button type="primary" @click="saveForm" class="submitBtn">保存</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')" class="submitBtn">提交</el-button>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
                <div class="dialogformBottomBtnBox" v-else>
                    <el-button @click="cancelForm" class="cancelBtn">关闭</el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import { httpService } from "@/service/httpService";
export default {
    props: ['saveId', 'result'],
    data() {
        return {
            ruleForm: {
                1: '',
                2: '',
                3: '',
                4: '',
                5: '',
                6: '',
                7: '',
                8: '',
                9: '',
                10: '',
                11: '',
                12: '',
                13: '',
                14: '',
                15: '',
                16: '',
                17: '',
                18: '',
                19: '',
                20: '',
                21: '',
                22: '',
                23: '',
                24: '',
                25: '',
                26: '',
                27: '',
                28: '',
                29: '',
                30: '',
                31: '',
                32: '',
                33: '',
                34: '',
                35: '',
                36: '',
                37: '',
                38: '',
                39: '',
                40: '',
                41: '',
            },
            rules: {
                // 正整数
                1: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                2: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],

                3: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                ],
                4: [
                    { required: true, message: '请选择', trigger: 'change' }

                ],
                // 小数
                5: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                6: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                7: [
                    { required: true, message: '请选择', trigger: 'change' }

                ],
                8: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                // 多选
                9: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                10: [
                    { required: true, message: '请选择', trigger: 'change' },
                ],
                11: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                12: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                13: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                14: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                15: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                16: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                17: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                18: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                19: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                20: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                21: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                22: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                23: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                24: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                25: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                26: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                27: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                28: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                29: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },

                ],
                30: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                31: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                32: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: /^(?:0|[1-9][0-9]?|100)$/, message: '只能输入0-100,例 1 代表 1%', trigger: 'blur' },
                ],
                33: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                34: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                35: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                36: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                37: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                38: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
                39: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^[0-9]*[1-9][0-9]*$', message: '请输入大于0的正整数', trigger: 'blur' },
                    // { pattern: '^[1-9]\\d{0,20}(\\.\\d{1,2})?$|^0(\\.\\d{1,2})?$', message: '请输入大于等于0的正整数，最多保留2位小数', trigger: 'blur' },
                ],
                40: [
                    { required: true, message: '请输入', trigger: 'blur' },
                    { pattern: '^(0|[1-9][0-9]*)$', message: '请输入大于等于0的正整数', trigger: 'blur' },
                ],
                41: [
                    { required: true, message: '请选择', trigger: 'change' }
                ],
            },
        }
    },
    created() {
        this.yetData()
    },
    methods: {
        saveForm() {
            let NewDataList = []
            for (const key in this.ruleForm) {
                let obj = {}
                obj.serialNumber = key;
                obj.evaluateValue = this.ruleForm[key]
                NewDataList.push(obj)
            }
            httpService.saveB(this.saveId, NewDataList).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$emit('getyetServiceFn')
                }
            })
        },
        // 提交
        submitForm(formName) {
            // 保存不通过validate检验
            this.$refs[formName].validate((valid, obj) => {
                if (valid) {
                    let NewDataList = []
                    // this.ruleForm[1] = this.ruleForm[1].join(',')
                    // this.ruleForm[7] = this.ruleForm[7].join(',')
                    for (const key in this.ruleForm) {
                        let obj = {}
                        obj.serialNumber = key;
                        obj.evaluateValue = this.ruleForm[key]
                        NewDataList.push(obj)
                    }
                    httpService.addScore(this.saveId,NewDataList).then(res => {
                        if (res.code == 200) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            });
                            this.$emit('getyetServiceFn')
                        }
                    })
                } else {
                    let arr = []
                    for (const key in obj) {
                        if (Object.hasOwnProperty.call(obj, key)) {
                            let ele = key + '题、'
                            arr.push(ele)
                        }
                    }
                    let str = arr.join('')
                    this.$message.error(`${str}未填写，请检查！`);
                    return false;
                }
            });
        },
        cancelForm() {
            this.$emit('getyetServiceFn')
        },
        // 回填表单数据
        yetData() {
              httpService.getCorpIndicatorOption(this.saveId).then(res => {
                if (res.code == 200) {
                    if (res.result.length != 0) {
                        let obj = {}
                        for (const key in res.result) {
                            obj[res.result[key].serialNumber] = res.result[key].evaluateValue
                        }
                        this.ruleForm = obj
                        // this.ruleForm[1] = this.ruleForm[1].split(',')
                        // this.ruleForm[7] = this.ruleForm[7].split(',')
                    }
                }
            })
        },
    }


}
</script>
<style lang="less" scoped>
.mainbusinessModal2Warp {
}
</style>


